import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-interservice-navbar',
  imports: [],
  template: `<wiz-sidebar [environment]="env" menuOption />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InterserviceNavbarComponent {
  readonly env = environment.platform;
}
